module.exports = __webpack_public_path__ + "static/img/logo.2547bad1.png";